import api from './api';
import { v4 as uuidv4 } from 'uuid';
import convertVapidKey from 'convert-vapid-public-key';
import i18n from '@/plugins/i18n';

const state = getDefaultState();

function getDefaultState() {
	return {
		platform: 'web',
		error: false,
		message: '',
	};
}
const actions = {
	async requestNotificationPermission({ dispatch, commit }) {
		if (!('Notification' in window)) {
			commit('setError', { message: i18n.t('permission_notification.error'), error: true });
			return;
		}

		const permission = await Notification.requestPermission();

		if (permission === 'granted') {
			await dispatch('subscribe');
		}
	},
	async getApplicationServerKey({ commit }) {
		try {
			const key = await api.getApplicationServerKey();
			return key.data;
		} catch (error) {
			commit('setError', { message: error.response?.data.message, error: true });
		}
	},
	async registerDevice({ state, commit, dispatch }, subscription) {
		let deviceId = window.localStorage.getItem('web-push.deviceId');
		if (!deviceId) {
			deviceId = uuidv4();
			window.localStorage.setItem('web-push.deviceId', deviceId);
		}
		const { endpoint, keys } = subscription.toJSON();
		try {
			const deviceData = {
				uid: deviceId,
				platform: state.platform,
				properties: {
					endpoint: endpoint,
					keys: {
						p256dh: keys.p256dh,
						auth: keys.auth,
					},
				},
			};

			await api.registerDevice(deviceData);
			//await dispatch('startSubscriptionTimer');
		} catch (error) {
			commit('setError', { message: error.response?.data.message, error: true });
		}
	},

	async stopSubscriptionTimer() {
		const registration = await navigator.serviceWorker.ready;

		if (registration.active) {
			registration.active.postMessage({
				type: 'STOP_TIMER',
			});
		}
	},

	async unregisterDevice({ commit, dispatch }) {
		try {
			const deviceId = localStorage.getItem('web-push.deviceId');
			if (deviceId) {
				await api.unregisterDevice(deviceId);
				await dispatch('unsubscribe');
			}
		} catch (error) {
			commit('setError', { message: error.response?.data.message, error: true });
		}
	},
	async subscribe({ dispatch }) {
		const registration = await navigator.serviceWorker?.ready;
		if (registration) {
			const key = await dispatch('getApplicationServerKey');
			if (key) {
				const subscription = await registration.pushManager.subscribe({
					userVisibleOnly: true,
					applicationServerKey: convertVapidKey(key),
				});
				if (subscription) {
					await dispatch('registerDevice', subscription);
				}
			}
		}
	},
	async unsubscribe() {
		const registration = await navigator.serviceWorker.ready;
		if (registration) {
			const subscription = await registration.pushManager.getSubscription();
			if (subscription) {
				await subscription.unsubscribe();
				localStorage.removeItem('web-push.deviceId');
			}
		}
	},
	resetError({ commit }) {
		commit('setError', { message: '', error: false });
	},
	removeError({ commit }) {
		commit('removeError');
	},
};

const mutations = {
	setError(state, { error, message }) {
		state.error = error;
		state.message = message;
	},
	removeError(state) {
		state.error = false;
		state.message = '';
	},
};
export default {
	namespaced: true,
	state,
	actions,
	mutations,
};
